import React, { Component, TextArea } from 'react';
import PropTypes from 'prop-types';
import FieldTextAreaStateless from './FieldTextAreaStateless'

class FieldTextArea extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    let questionData = this.props.questionData;
    if (this.props.onChange) this.props.onChange(e.target.value, questionData, "response");
  }

  render() {
    return (
      <FieldTextAreaStateless
        {...this.props}
        value={this.props.value}
        onChange={this.handleOnChange}
      />
    );
  }
}

export default FieldTextArea;
